export function useTimer() {
  return {
    startCountdown: (seconds: number, label: string): void => {
      window.startCountdown?.(seconds, label)
    },
    startStopwatch: (label: string, mode: string): void => {
      window.startStopwatch?.(label, mode)
    },
  }
}
